<template>
<div>
    <div class="columns">
        <div class="column">
            <h2 class="title is-3">Автоматическая регистрация пользователей</h2>
        </div>
    </div>
    <section>
        <div class="columns">
            <div class="column is-4">
                <b-field label="Файл" >
                    <b-upload v-model="file"
                        accept=".xlsx"
                        drag-drop>
                        <section class="section">
                            <div class="content has-text-centered">
                                <p>
                                    <b-icon
                                        icon="upload"
                                        size="is-large">
                                    </b-icon>
                                </p>
                                <span class="file-name" v-if="file" >
                                    {{ file.name }}
                                </span>
                                <span v-else>
                                    <p>Загрузить файл</p>
                                    <p>В формате .xlsx</p>
                                </span>
                            </div>
                        </section>
                    </b-upload>
                </b-field>
            </div>
            <div class="column is-3">
                <b-field label="utm_source">
                    <b-input v-model="utm_source"></b-input>
                </b-field>
                <div class="columns">
                    <div class="column is-3">
                        <div class="columns" style="margin-top: 50px; margin-left: 5px">
                            <b-button type="is-primary" @click="sendFile()">Зарегистрировать</b-button>
                        </div>
                        <div class="columns" style="margin-top: 10px; margin-left: 5px">
                            <b-button type="is-primary" @click="createModal()">СМС с авторегистрацией</b-button>
                        </div>
                        <div class="columns" style="margin-top: 10px; margin-left: 5px">
                            <b-button type="is-primary" @click="createCallModal()">Звонок с авторегистрацией</b-button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
</div>
</template>

<script>
import { AxiosClient } from '@/app/shared/services';
import AutoRegistrationSmsTemplate from '@/app/admin/notifications/shared/modals/autoRegistrationSmsTemplate';
import AutoRegistrationCallTemplate from '@/app/admin/notifications/shared/modals/autoRegistrationCallTemplate';

export default {
  name: 'AutoRegistration',
  data() {
    return {
      utm_source: '',
      file: null,
    };
  },
  methods: {
    sendFile() {
      const formData = new FormData();
      formData.append('utm_source', this.utm_source);
      formData.append('file', this.file);
      AxiosClient.post('/profile/auto_registration',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((data) => {
          this.$toaster.success('Авторегистрация запущена в фоновом режиме');
        })
        .catch((error) => {
          this.$toaster.error(`Ошибка!${error}`);
        });
    },
    createModal() {
      const props = {
        file: this.file,
        utm_source: this.utm_source,
      };
      this.$buefy.modal.open({
        parent: this,
        props,
        component: AutoRegistrationSmsTemplate,
        hasModalCard: true,
        width: 2000,
      });
    },
      createCallModal() {
          const props = {
              file: this.file,
              utm_source: this.utm_source,
          };
          this.$buefy.modal.open({
              parent: this,
              props,
              component: AutoRegistrationCallTemplate,
              hasModalCard: true,
              width: 2000,
          });
      },
  },
};
</script>

<style>

</style>
